// Mock metadata que define os campos disponíveis no Rule Engine
export const MOCK_METADATA = {
  "fields": [
    {
      "id": "tipo_locacao",
      "label": "Tipo de Locação",
      "type": "select",
      "operators": [
        { "value": "is", "label": "É" }
      ],
      "options": [
        { "value": "RESIDENCIAL", "label": "Residencial" },
        { "value": "NAO_RESIDENCIAL", "label": "Não Residencial" }
      ]
    },
    {
      "id": "faixa_valor_locacao",
      "label": "Faixa de Valor da Locação",
      "type": "currency",
      "operators": [
        { "value": "between", "label": "Entre" }
      ],
      "help_text": "Compara o total Aluguel + Condomínio + IPTU da locação."
    },
    {
      "id": "tipo_pretendente",
      "label": "Tipo de Pretendente",
      "type": "multi_select",
      "operators": [
        { "value": "in", "label": "Está em" },
        { "value": "not_in", "label": "Não está em" }
      ],
      "options": [
        { "value": "INQUILINO", "label": "Inquilino" },
        { "value": "INQUILINO_ESTUDANTE", "label": "Inquilino estudante" },
        { "value": "FIADOR", "label": "Fiador" },
        { "value": "FIADOR_ESTUDANTE", "label": "Fiador de estudante" },
        { "value": "CONJUGE_INQUILINO", "label": "Cônjuge do Inquilino" },
        { "value": "CONJUGE_FIADOR", "label": "Cônjuge do Fiador" },
        { "value": "OUTROS", "label": "Outros" }
      ]
    },
    {
      "id": "score_fc",
      "label": "Score FC",
      "type": "numeric",
      "operators": [
        { "value": "greater_equal", "label": "Maior ou igual a" },
        { "value": "less_equal", "label": "Menor ou igual a" },
        { "value": "between", "label": "Entre" }
      ]
    },
    {
      "id": "risco_fc",
      "label": "Risco FC",
      "type": "multi_select",
      "operators": [
        { "value": "in", "label": "Está em" },
        { "value": "not_in", "label": "Não está em" }
      ],
      "options": [
        { "value": "PARECER_NIVEL_1", "label": "Muito Baixo" },
        { "value": "PARECER_NIVEL_2", "label": "Baixo" },
        { "value": "PARECER_NIVEL_3", "label": "Médio" },
        { "value": "PARECER_NIVEL_4", "label": "Acima da Média" },
        { "value": "PARECER_NIVEL_5", "label": "Muito Alto" }
      ]
    },
    {
      "id": "renda_informada",
      "label": "Renda Informada (Multiplicador)",
      "type": "numeric",
      "operators": [
        { "value": "greater_than", "label": "Maior que" },
        { "value": "less_than", "label": "Menor que" },
        { "value": "between", "label": "Entre" }
      ],
      "step": "0.1"
    },
    {
      "id": "renda_presumida",
      "label": "Renda Presumida (Multiplicador)",
      "type": "numeric",
      "operators": [
        { "value": "greater_than", "label": "Maior que" },
        { "value": "less_than", "label": "Menor que" },
        { "value": "between", "label": "Entre" }
      ],
      "step": "0.1"
    },
    {
      "id": "origem_renda",
      "label": "Origem de Renda",
      "type": "multi_select",
      "operators": [
        { "value": "in", "label": "Está em" },
        { "value": "not_in", "label": "Não está em" }
      ],
      "options": [
        { "value": "16", "label": "Não Possui Renda" },
        { "value": "11", "label": "Funcionário Privado Registrado (CLT)" },
        { "value": "2", "label": "Funcionário Público (Estatutário)" },
        { "value": "3", "label": "Funcionário Público (CLT)" },
        { "value": "4", "label": "Empresário" },
        { "value": "5", "label": "Profissional Liberal ou Autônomo" },
        { "value": "6", "label": "Aposentado ou Pensionista" },
        { "value": "12", "label": "Militar" },
        { "value": "7", "label": "Renda de Aluguel" },
        { "value": "8", "label": "Pensão Alimentícia ou Judicial" },
        { "value": "9", "label": "Estagiário ou Bolsista" },
        { "value": "13", "label": "Limite do Cartão de Crédito" },
        { "value": "15", "label": "Extratos Bancários" },
        { "value": "14", "label": "Outro" },
        { "value": "1", "label": "Origem Não Informada" }
      ],
      "sub_fields": [
        {
          "id": "soma_renda",
          "label": "Filtrar por soma de renda das origens selecionadas (multiplicador)",
          "type": "numeric",
          "optional": true,
          "operators": [
            { "value": "greater_than", "label": "Maior que" },
            { "value": "less_than", "label": "Menor que" },
            { "value": "between", "label": "Entre" }
          ],
          "step": "0.1"
        }
      ]
    },
    {
      "id": "risco_credito_mercado",
      "label": "Risco de Crédito (Mercado)",
      "type": "multi_select",
      "operators": [
        { "value": "in", "label": "Está em" },
        { "value": "not_in", "label": "Não está em" }
      ],
      "options": [
        { "value": "PARECER_NIVEL_1", "label": "Muito Baixo" },
        { "value": "PARECER_NIVEL_2", "label": "Baixo" },
        { "value": "PARECER_NIVEL_3", "label": "Médio" },
        { "value": "PARECER_NIVEL_4", "label": "Acima da Média" },
        { "value": "PARECER_NIVEL_5", "label": "Muito Alto" }
      ]
    },
    {
      "id": "negativacao",
      "label": "Negativação",
      "type": "compound_boolean",
      "operators": [
        { "value": "is", "label": "É (Presença)" }
      ],
      "options": [
        { "value": true, "label": "Sim" },
        { "value": false, "label": "Não" }
      ],
      "sub_fields": [
        {
          "id": "quantidade",
          "label": "Qtd. Máxima",
          "type": "numeric",
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        },
        {
          "id": "valor",
          "label": "Valor Máx (R$)",
          "type": "currency",
          "optional": true,
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        },
        {
          "id": "valor_percentual",
          "label": "Percentual sobre renda (%)",
          "type": "percent",
          "optional": true,
          "max": 100,
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        }
      ]
    },
    {
      "id": "acoes_despejo",
      "label": "Ações - Despejo/Locação",
      "type": "compound_boolean",
      "operators": [
        { "value": "is", "label": "É (Presença)" }
      ],
      "options": [
        { "value": true, "label": "Sim" },
        { "value": false, "label": "Não" }
      ],
      "sub_fields": [
        {
          "id": "quantidade",
          "label": "Qtd. Máxima",
          "type": "numeric",
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        },
        {
          "id": "tempo",
          "label": "Tempo Máx (meses)",
          "type": "numeric",
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        }
      ]
    },
    {
      "id": "acoes_criminais",
      "label": "Ações - Criminais",
      "type": "compound_boolean",
      "operators": [
        { "value": "is", "label": "É (Presença)" }
      ],
      "options": [
        { "value": true, "label": "Sim" },
        { "value": false, "label": "Não" }
      ],
      "sub_fields": [
        {
          "id": "quantidade",
          "label": "Qtd. Máxima",
          "type": "numeric",
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        },
        {
          "id": "tempo",
          "label": "Tempo Máx (meses)",
          "type": "numeric",
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        }
      ]
    },
    {
      "id": "acoes_outras_reu",
      "label": "Ações - Outras (Réu)",
      "type": "compound_boolean",
      "operators": [
        { "value": "is", "label": "É (Presença)" }
      ],
      "options": [
        { "value": true, "label": "Sim" },
        { "value": false, "label": "Não" }
      ],
      "sub_fields": [
        {
          "id": "quantidade",
          "label": "Qtd. Máxima",
          "type": "numeric",
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        },
        {
          "id": "tempo",
          "label": "Tempo Máx (meses)",
          "type": "numeric",
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        }
      ]
    },
    {
      "id": "acoes_outras_autor",
      "label": "Ações - Outras (Autor)",
      "type": "compound_boolean",
      "operators": [
        { "value": "is", "label": "É (Presença)" }
      ],
      "options": [
        { "value": true, "label": "Sim" },
        { "value": false, "label": "Não" }
      ],
      "sub_fields": [
        {
          "id": "quantidade",
          "label": "Qtd. Máxima",
          "type": "numeric",
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        },
        {
          "id": "tempo",
          "label": "Tempo Máx (meses)",
          "type": "numeric",
          "operators": [
            { "value": "less_equal", "label": "Menor ou igual a" },
            { "value": "greater_equal", "label": "Maior ou igual a" }
          ]
        }
      ]
    }
  ]
};

// Mock de regras para demonstração
export const MOCK_RULES = [
  {
    id: '1',
    name: 'Aprovação PF Risco Baixo',
    tenant_recommendation_text: 'Aprovado para locação com garantia padrão.',
    guarantor_recommendation_text: 'Fiador dispensado mediante seguro fiança.',
    is_active: true,
    priority: 0,
    conditions: [
      {
        field: 'tipo_pretendente',
        operator: 'in',
        value: ['INQUILINO']
      },
      {
        field: 'score_fc',
        operator: 'greater_equal',
        value: 700
      },
      {
        field: 'risco_fc',
        operator: 'in',
        value: ['PARECER_NIVEL_1', 'PARECER_NIVEL_2']
      }
    ]
  },
  {
    id: '2',
    name: 'Aprovação com Restrições - Negativação Controlada',
    tenant_recommendation_text: 'Aprovado com garantia reforçada (2 fiadores ou caução).',
    guarantor_recommendation_text: 'Exigir 2 fiadores com score mínimo de 650.',
    is_active: true,
    priority: 1,
    conditions: [
      {
        field: 'tipo_pretendente',
        operator: 'in',
        value: ['INQUILINO']
      },
      {
        field: 'score_fc',
        operator: 'between',
        value: { min: 500, max: 699 }
      },
      {
        field: 'negativacao',
        operator: 'is',
        value: true,
        sub_conditions: {
          quantidade: {
            operator: '<=',
            value: 2
          },
          valor: {
            operator: '<=',
            value: 5000
          }
        }
      }
    ]
  },
  {
    id: '3',
    name: 'Reprovação - Alto Risco',
    tenant_recommendation_text: 'Não recomendado para locação.',
    guarantor_recommendation_text: 'Não se aplica.',
    is_active: true,
    priority: 2,
    conditions: [
      {
        field: 'risco_fc',
        operator: 'in',
        value: ['muito_alto']
      },
      {
        field: 'acoes_despejo',
        operator: 'is',
        value: true,
        sub_conditions: {
          quantidade: {
            operator: 'greater_equal',
            value: 1
          },
          tempo: {
            operator: 'less_equal',
            value: 24
          }
        }
      }
    ]
  },
  {
    id: '4',
    name: 'Origem pública com renda mínima',
    tenant_recommendation_text: 'Aprovado: composição de renda de origem pública/aposentadoria atende o múltiplo mínimo exigido.',
    guarantor_recommendation_text: 'Não se aplica.',
    is_active: true,
    priority: 3,
    conditions: [
      {
        field: 'origem_renda',
        operator: 'in',
        value: [2, 3, 6],
        sub_conditions: {
          soma_renda: {
            enabled: true,
            operator: 'greater_than',
            value: 3
          }
        }
      }
    ]
  }
];
